import Loading from "../../utils/Loading"; //获取加载组件

export default {
	name: 'ModuleBox',
	components: {

	},
	data(){
		return{


		}
	},
	methods:{





	},
	mounted(){

	}
}

